import { getLossyDownsampling, getShouldUseCPURendering } from '../init.js';
const GIGABYTE = 1024 * 1024 * 1024;
const PRESETS = {
    'low-tablet': {
        id: 'low-tablet',
        maxTextureEdge: 256,
        textureMemoryBytes: 1 * GIGABYTE,
        speed: 10,
    },
    low: {
        id: 'low',
        maxTextureEdge: 256,
        textureMemoryBytes: 2 * GIGABYTE,
        speed: 30,
    },
    medium: {
        id: 'medium',
        maxTextureEdge: 2048,
        textureMemoryBytes: 8 * GIGABYTE,
        speed: 60,
    },
    high: {
        id: 'high',
        maxTextureEdge: 2048,
        textureMemoryBytes: 32 * GIGABYTE,
        speed: 100,
    },
    'high-texture-4096': {
        id: 'high-texture-4096',
        maxTextureEdge: 4096,
        textureMemoryBytes: 32 * GIGABYTE,
        speed: 100,
        internal: true,
    },
};
const DEFAULT_PRESET_ID = 'high';
let activePresetId = DEFAULT_PRESET_ID;
function getGpuSettingsPresets() {
    return Object.values(PRESETS);
}
function getGpuSettingsPreset(id) {
    const preset = Object.prototype.hasOwnProperty.call(PRESETS, id)
        ? PRESETS[id]
        : undefined;
    if (!preset) {
        throw new Error(`gpuSettingsPresets: there is no preset named ${id}`);
    }
    return preset;
}
function setGpuSettingsPreset(id) {
    getGpuSettingsPreset(id);
    activePresetId = id;
}
function getActiveGpuSettings() {
    return getGpuSettingsPreset(activePresetId);
}
function gpuSettingsForRender() {
    return getLossyDownsampling().final && !getShouldUseCPURendering()
        ? getActiveGpuSettings()
        : undefined;
}
function resetGpuSettingsPreset() {
    activePresetId = DEFAULT_PRESET_ID;
}
function gridLimitsOfGpuSettings(gpuSettings, bytesPerVoxel) {
    const limits = { maxEdge: gpuSettings.maxTextureEdge };
    if (bytesPerVoxel > 0 && gpuSettings.textureMemoryBytes > 0) {
        limits.maxVoxelCount = Math.floor(gpuSettings.textureMemoryBytes / bytesPerVoxel);
    }
    return limits;
}
export { getGpuSettingsPreset, getGpuSettingsPresets, setGpuSettingsPreset, getActiveGpuSettings, gpuSettingsForRender, resetGpuSettingsPreset, gridLimitsOfGpuSettings, DEFAULT_PRESET_ID as defaultGpuSettingsPresetId, };
